/** @module Enums */ /** typedoc */

export enum CollaborationActorEnum {
    Owner = 'Owner',
    Collaborator = 'Collaborator'
}
